<div class="row">


  <div class="col-12">
    <div class="file-upload" [ngClass]="{'uploading': uploading}">
      <div ng2FileDrop [ngClass]="{'file-over': fileOverDropZone}" class="drop-zone" (fileOver)="fileOver($event)"
        (onFileDrop)="fileDropped($event)" [uploader]="uploader">
        <div class="frame clickable" (click)="openFileSelect()">
          <div class="text">
            <h2 *ngIf="!customText">{{ 'Släpp fil här' | translate }}</h2>
            <h2 *ngIf="customText">{{customText}}</h2>
          </div>
        </div>
      </div>
      <input type="file" #fileInput ng2FileSelect [uploader]="uploader" style="display: none" />
      <div *ngIf="uploading">
        <h3 *ngIf="!uploadingComplete">{{ 'Laddar upp..' | translate }}</h3>
      </div>
    </div>

  </div>

</div>
